import { render } from "./Previous.vue?vue&type=template&id=24ce0d8c&scoped=true"
import script from "./Previous.vue?vue&type=script&lang=js"
export * from "./Previous.vue?vue&type=script&lang=js"

import "./Previous.vue?vue&type=style&index=0&id=24ce0d8c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ce0d8c"]])

export default __exports__